import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import {
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  FormControlLabel,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Switch
} from '@material-ui/core';
import LoadingSpinner from '../../components/LoadingSpinner';
import { updateGlobalSettingsAction } from '../../reducers/settings';
import { EDITABLE_GLOBAL_SETTINGS } from '../../constants/settings';
import { getGlobalSettings } from '../../selectors/globalSettings';

const General = () => {
  const dispatch = useDispatch();
  const globalSettings = useSelector(getGlobalSettings);
  const [updatingKey, setUpdatingKey] = useState(null);

  const handleToggle = (key, currentValue) => {
    setUpdatingKey(key);
    dispatch(updateGlobalSettingsAction({ [key]: !currentValue })).finally(() => {
      setUpdatingKey(null);
    });
  };

  return (
    <Container maxWidth="md">
      <Card>
        <CardHeader
          title="General"
          subheader="Global settings that apply across the application."
        />
        <Divider />
        <CardContent>
          <List>
            {EDITABLE_GLOBAL_SETTINGS.map(setting => {
              const enabled = Boolean(get(globalSettings, setting.key));
              const isUpdating = updatingKey === setting.key;

              return (
                <ListItem key={setting.key}>
                  <ListItemText primary={setting.title} secondary={setting.description} />
                  <ListItemSecondaryAction>
                    <FormControlLabel
                      edge="end"
                      control={
                        <Switch color="primary" checked={enabled} disabled={Boolean(updatingKey)} />
                      }
                      onChange={() => handleToggle(setting.key, enabled)}
                      label={<LoadingSpinner show={isUpdating} />}
                      labelPlacement="start"
                      disabled={Boolean(updatingKey)}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        </CardContent>
      </Card>
    </Container>
  );
};

export default General;
